import { create } from 'zustand';

export const useContactsCreateStore = create((set) => ({
  isOpen: false,
  payload: {},
  callback: null, //
  openContactsCreate: (payload,callback=null) => set({ isOpen: true, payload,callback }),
  close: (result) => set((state) => {
    // Call callback if exists, and clear everything
    if (state.callback) state.callback(result);
    return { isOpen: false, payload: {}, callback: null};
  }),
}));
export const openContactsCreate = (payload) => {
  const store = useContactsCreateStore.getState();
  store.openContactsCreate(payload);
};

export const closeContactsCreate = () => {
  const store = useContactsCreateStore.getState();
  store.close();
};